<div class="main">
    <div class="title">
        Activity Tracker
    </div>
    
    <div class="buttons"
    style="padding-top: 0.5%;">
        <a class="uploadscedule" routerLink="/management/uploadsched">
                Upload scedule
            </a>
            
        <a class="viewscedule" routerLink="/management/viewscedule">
            View scedule
        </a>
        <div class="todo" (click)="todoggle(true)">
            To do list
        </div>
    </div>
    <div class="month">
        May 2021
    </div>
    <div class="alldays">        
        <div class="day" *ngFor="let x of days">
            <!-- <span class="border border-left-0"></span> -->
            <div style="flex-basis: 50%; font-size: 200%;"> 
                {{x.date}}
            </div>
            <div style="flex-basis: 50%;padding-top: 10%; padding-left: 10%;">{{x.day}}</div>
            <div style="flex-basis: 50%; padding-top: 33%; font-size: 150%;" (click)="toggle(true, x.date)">
                <div class="plus">+</div>
            </div>
        </div>

    </div>
    <div class="plusform" *ngIf = "showform">
        <div class = "formcont">
            <div class = "formtitle">
                Add Activity
            </div>
            <form [formGroup]="addactorrem" class = "form" >
                <input type = "text" placeholder="Enter Name" class = "input" formControlName = "ActivityName">
                <input type = "text" placeholder="Enter Time" class = "input" formControlName = "ActivityTime">
                <mat-form-field>
                    <mat-label style="font-size: 80%; color: black;">Select Type</mat-label>
                    <mat-select [(value)]="type"
                        style="text-align: center; font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;">
                        <mat-option value="{{x.name}}" *ngFor = "let x of catoptions">
                            {{x.displayname}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class = "submitbut" (click)="submitactrem()">
                    Submit
                </div>
            </form>
        </div>
    </div>

    <div class="todoform" *ngIf = "todoshow">
        <div class = "formcont">
            <div class = "formtitle">
                Your To Do List
            </div>
            <form [formGroup]="todoform" class = "form"  *ngFor = "let x of reminder">
                <div style = "display: flex; justify-content: space-evenly;">
                    <input type = "checkbox" placeholder="Enter Name" class = "input">
                    <label>{{x.payload.doc.data().ActivityName}} on 3rd May 2021 at {{x.payload.doc.data().ActivityTime}}</label>
                </div>
                <div class = "submitbut" (click)="todoggle(false)">
                    Done
                </div>
            </form>
        </div>
    </div>
</div>